import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Layout from '@/components/layout/Layout.vue' // 👈 你的布局组件

const routes: Array<RouteRecordRaw> = [
{
    path: '/',
    component: Layout, // 👈 外层壳
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'data',
        name: 'data',
        component: () => import('@/views/data/index.vue'),
        meta: { title: '表型图谱', requiresAuth: true },
      },
      {
        path: 'analysis',
        name: 'analysis',
        component: () => import('@/views/analysis/index.vue'),
        meta: { title: '表型数据库', requiresAuth: true },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/common/LoginView.vue'),
    meta: { title: '登录 - NeuroMap AI' },
  },
  // // 私有路由（需要登录才能访问）
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/AboutView.vue'),
  //   meta: { title: '关于我们', requiresAuth: true }, // requiresAuth: true 标记需要登录
  // },
  // 404 路由（匹配所有未定义路由）
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/common/NotFoundView.vue'),
    meta: { title: '404页面不存在' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫：全局修改页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath,
          notice: '请先登录后再访问该页面',
        },
      })
      return
    }
  }

  next()
})

export default router
